/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Workout_Quick_OverlapInputs */

const en_us2_workout_quick_overlap = /** @type {(inputs: Workout_Quick_OverlapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`There's already a workout logged from ${i?.from} to ${i?.to}. Check the time: saving adds another workout.`)
};

const pt_br2_workout_quick_overlap = /** @type {(inputs: Workout_Quick_OverlapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Já há um treino registrado das ${i?.from} às ${i?.to}. Confira o horário: salvar cria mais um treino.`)
};

const es_419_workout_quick_overlap = /** @type {(inputs: Workout_Quick_OverlapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ya hay un entrenamiento registrado de ${i?.from} a ${i?.to}. Revisa la hora: guardar agrega otro entrenamiento.`)
};

const pt_pt2_workout_quick_overlap = /** @type {(inputs: Workout_Quick_OverlapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Já há um treino registado das ${i?.from} às ${i?.to}. Verifica a hora: guardar cria mais um treino.`)
};

const fr_fr2_workout_quick_overlap = /** @type {(inputs: Workout_Quick_OverlapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Une séance est déjà enregistrée de ${i?.from} à ${i?.to}. Vérifie l'heure : enregistrer ajoute une autre séance.`)
};

const de_de2_workout_quick_overlap = /** @type {(inputs: Workout_Quick_OverlapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Es gibt schon ein Training von ${i?.from} bis ${i?.to}. Prüf die Uhrzeit: Speichern legt ein weiteres Training an.`)
};

const it_it2_workout_quick_overlap = /** @type {(inputs: Workout_Quick_OverlapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`C'è già un allenamento registrato dalle ${i?.from} alle ${i?.to}. Controlla l'orario: salvando aggiungi un altro allenamento.`)
};

/**
* | output |
* | --- |
* | "There's already a workout logged from {from} to {to}. Check the time: saving adds another workout." |
*
* @param {Workout_Quick_OverlapInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_overlap = /** @type {((inputs: Workout_Quick_OverlapInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_OverlapInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_overlap(inputs)
	if (locale === "es-419") return es_419_workout_quick_overlap(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_overlap(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_overlap(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_overlap(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_overlap(inputs)
	return en_us2_workout_quick_overlap(inputs)
});
export { workout_quick_overlap as "workout-quick.overlap" }